// project imports
import { withAlpha } from 'utils/colorUtils';

// ==============================|| DEFAULT THEME - CUSTOM SHADOWS ||============================== //

export default function CustomShadows(palette) {
  return {
    button: `0 1px 2px rgba(0,0,0,0.05)`,
    text: `0 -1px 0 rgb(0 0 0 / 12%)`,
    z1: `0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)`,
    primary: `0 0 0 2px ${withAlpha(palette.primary.main, 0.15)}`,
    secondary: `0 0 0 2px ${withAlpha(palette.secondary.main, 0.15)}`,
    error: `0 0 0 2px ${withAlpha(palette.error.main, 0.15)}`,
    warning: `0 0 0 2px ${withAlpha(palette.warning.main, 0.15)}`,
    info: `0 0 0 2px ${withAlpha(palette.info.main, 0.15)}`,
    success: `0 0 0 2px ${withAlpha(palette.success.main, 0.15)}`,
    grey: `0 0 0 2px ${withAlpha(palette.grey[500], 0.15)}`,
    primaryButton: `0 4px 14px ${withAlpha(palette.primary.main, 0.2)}`,
    secondaryButton: `0 4px 14px ${withAlpha(palette.secondary.main, 0.2)}`,
    errorButton: `0 4px 14px ${withAlpha(palette.error.main, 0.2)}`,
    warningButton: `0 4px 14px ${withAlpha(palette.warning.main, 0.2)}`,
    infoButton: `0 4px 14px ${withAlpha(palette.info.main, 0.2)}`,
    successButton: `0 4px 14px ${withAlpha(palette.success.main, 0.2)}`,
    greyButton: `0 4px 14px ${withAlpha(palette.grey[500], 0.2)}`
  };
}
